import React, { useContext } from "react";
import { LanguageContext } from "./LanguageContext";
import classes from "./LanguageSelector.module.css";

const LanguageSelector = () => {
  const { lang, setLang } = useContext(LanguageContext);

  const toggleLang = () => {
    const newLang = lang === "ar" ? "eng" : "ar";
    setLang(newLang); // THIS IS ENOUGH
  };

  return (
    <div className={classes.toggleWrapper} onClick={toggleLang}>
      <div className={`${classes.slider} ${lang === "eng" ? classes.eng : classes.ar}`}>
        <span className={classes.option}>E</span>
        <span className={classes.option}>ع</span>
      </div>

      <div className={`${classes.circle} ${lang === "eng" ? classes.circleEng : classes.circleAr}`}>
        {lang === "eng" ? "E" : "ع"}
      </div>
    </div>
  );
};

export default LanguageSelector;
